import React, { useEffect, useState } from 'react';
import { ArcAlert, ArcStack, ArcText, ArcToolbar } from '@src/core/ui';
import { useNavigate, useParams } from 'react-router-dom';
import { Actions, DetailsInfo, RouteInfo } from './components';
import { useRequestAuthMutation } from '../../redux';
import { MissionIdParams } from '@src/core/entities';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const getMessageLines = (message: string): { firstLine: string; secondLine: string | null } => {
  const parts = message.split(/\.\s+/).filter(Boolean);
  const sentences = parts.map((p, i) => (i < parts.length - 1 ? `${p}.` : p));
  const hasThird = sentences.length >= 3;
  return {
    firstLine: hasThird ? sentences.slice(0, 2).join(' ') : message,
    secondLine: hasThird ? sentences.slice(2).join(' ') : null,
  };
};

const WarningAlert: React.FC<{ message: string }> = ({ message }) => {
  const { firstLine, secondLine } = getMessageLines(message);
  return (
    <ArcAlert severity='error' icon={<WarningAmberIcon />} sx={{ bgcolor: 'error.background', py: 0.4, px: 1, '& .MuiAlert-icon': { marginLeft: '3px' } }}>
      <ArcStack spacing={0.001}>
        <ArcText.caption color='error.main'>{firstLine}</ArcText.caption>
        {secondLine != null && <ArcText.caption color='error.main'>{secondLine}</ArcText.caption>}
      </ArcStack>
    </ArcAlert>
  );
};

const ConfirmOrderSidebar: React.FC = () => {

  const navigate = useNavigate();

  const [requestAuth] = useRequestAuthMutation();
  const { missionId } = useParams<MissionIdParams>();
  const [messages, setMessages] = useState<string[]>([]);

  const onRequestAuth = () => {
    if (!missionId) return;
    requestAuth(missionId).unwrap().then((res) => {
      setMessages(res?.warnings ?? []);
    });
  };

  useEffect(() => {
    onRequestAuth();
  }, [messages]);

  return (
    <ArcStack spacing={2} height='100%'>
      <ArcToolbar 
        title='4. Confirm details' 
        goBack={() => navigate(-1)} />

      <ArcStack height='100%' justifyContent='space-between'>

        <ArcStack spacing={2}>
          <DetailsInfo />
          <RouteInfo />
          <ArcStack spacing={1}>
            {messages.map((message) => (
              <WarningAlert key={message} message={message} />
            ))}
          </ArcStack>


          <Actions isWarnings={messages.length > 0} />
        </ArcStack>
      </ArcStack>
      
    </ArcStack>
  );
};

export default ConfirmOrderSidebar;